import React, { useEffect, useState } from 'react';
import { Cookie } from 'lucide-react';
import { useLanguage } from '../../assets/js/LanguageContext';
import { OPEN_COOKIE_SETTINGS_EVENT, getConsent, setConsent } from '../../utils/cookieConsent';
import '../../assets/styles/CookieBanner.css';

// Aviso de cookies: sale hasta que se elige y se vuelve a abrir desde el pie de página
const CookieBanner = () => {
  const { t } = useLanguage();
  const [open, setOpen] = useState(() => !getConsent());

  useEffect(() => {
    const reopen = () => setOpen(true);
    window.addEventListener(OPEN_COOKIE_SETTINGS_EVENT, reopen);
    return () => window.removeEventListener(OPEN_COOKIE_SETTINGS_EVENT, reopen);
  }, []);

  if (!open) return null;

  const choose = (value) => {
    setConsent(value);
    setOpen(false);
  };

  return (
    <section className="tp-cookies" aria-label={t('cookies_title')}>
      <span className="tp-cookies__icon" aria-hidden="true">
        <Cookie size={20} strokeWidth={1.9} />
      </span>
      <div className="tp-cookies__body">
        <p className="tp-cookies__title">{t('cookies_title')}</p>
        <p className="tp-cookies__text">
          {t('cookies_text')}{' '}
          <a href="/privacy#cookies" className="tp-cookies__link">{t('cookies_more')}</a>
        </p>
      </div>
      <div className="tp-cookies__actions">
        <button type="button" className="btn btn--outline btn--sm" onClick={() => choose('rejected')}>
          {t('cookies_reject')}
        </button>
        <button type="button" className="btn btn--primary btn--sm" onClick={() => choose('accepted')}>
          {t('cookies_accept')}
        </button>
      </div>
    </section>
  );
};

export default CookieBanner;
